import * as React from "react";

const IndexPage = () => {
  return (
    <main>
      <title>elsinor</title>
      <h1>elsinor</h1>
      <p>
        If you're seeing this page and you're not sure why, please get in touch
        at&nbsp;
        <a href="mailto:support@fourieraudio.com">support@fourieraudio.com</a>.
      </p>
    </main>
  );
};

export default IndexPage;
